import { render, staticRenderFns } from "./page-no-data.vue?vue&type=template&id=0dde4dc4&scoped=true&"
import script from "./page-no-data.vue?vue&type=script&lang=ts&"
export * from "./page-no-data.vue?vue&type=script&lang=ts&"
import style0 from "./page-no-data.vue?vue&type=style&index=0&id=0dde4dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde4dc4",
  null
  
)

export default component.exports